import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import type { AuditLogQuery, AuditOption, AuditResult } from '@/api/audit'

interface AuditLogFilterBarProps {
	query: AuditLogQuery
	modules: AuditOption[]
	actions: AuditOption[]
	onChange: (query: AuditLogQuery) => void
}

export function AuditLogFilterBar({ query, modules, actions, onChange }: AuditLogFilterBarProps) {
	const update = (patch: Partial<AuditLogQuery>) => onChange({ ...query, ...patch, page: 1 })
	const selectedModule = query.module || ''
	const visibleActions = selectedModule
		? actions.filter((option) => option.value.startsWith(`${selectedModule}.`))
		: actions

	const handleModuleChange = (value: string) => {
		const nextModule = value === 'all' ? undefined : value
		const actionBelongsToModule = !nextModule || !query.action || query.action.startsWith(`${nextModule}.`)
		update({
			module: nextModule,
			action: actionBelongsToModule ? query.action : undefined,
		})
	}

	return (
		<div className="grid gap-3 md:grid-cols-[1fr_160px_180px_140px_auto]">
			<Input
				placeholder="订单号或资源编号"
				value={query.resource_no || ''}
				onChange={(event) => update({ resource_no: event.target.value })}
			/>
			<Select value={query.module || 'all'} onValueChange={handleModuleChange}>
				<SelectTrigger aria-label="模块">
					<SelectValue placeholder="模块" />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="all">全部模块</SelectItem>
					{modules.map((option) => (
						<SelectItem key={option.value} value={option.value}>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<Select value={query.action || 'all'} onValueChange={(value) => update({ action: value === 'all' ? undefined : value })}>
				<SelectTrigger aria-label="操作">
					<SelectValue placeholder="操作" />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="all">全部操作</SelectItem>
					{visibleActions.map((option) => (
						<SelectItem key={option.value} value={option.value}>
							{option.label}
						</SelectItem>
					))}
				</SelectContent>
			</Select>
			<Select value={query.result || 'all'} onValueChange={(value) => update({ result: value === 'all' ? undefined : value as AuditResult })}>
				<SelectTrigger aria-label="结果">
					<SelectValue placeholder="结果" />
				</SelectTrigger>
				<SelectContent>
					<SelectItem value="all">全部结果</SelectItem>
					<SelectItem value="success">成功</SelectItem>
					<SelectItem value="failed">失败</SelectItem>
				</SelectContent>
			</Select>
			<Button variant="outline" onClick={() => onChange({ page: 1, page_size: query.page_size })}>
				重置
			</Button>
		</div>
	)
}
